import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import api from "../../services/api";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";
import { useTheme } from "@material-ui/core/styles";
import { getChartTextColor } from "./chartTheme";

ChartJS.register(ArcElement, Title, Tooltip, Legend, ChartDataLabels);

const SIM_COLOR = "#2DDD7F";
const NAO_COLOR = "#CC0036";

const buildOptions = textColor => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "top",
      display: true,
      labels: {
        color: textColor
      }
    },
    title: {
      display: true,
      text: i18n.t("dashboard.conversions.chartTitle"),
      color: textColor
    },
    datalabels: {
      display: true,
      color: "#fff",
      font: {
        size: 12,
        weight: "bold"
      },
      formatter: value => {
        const total = Math.trunc(Number(value) || 0);
        return total > 0 ? total : "";
      }
    }
  }
});

const initialState = {
  sim: 0,
  nao: 0,
  naoAplicavel: 0,
  totalTickets: 0,
  totalConversoes: 0,
  percentual: 0
};

export const ChartsConvertedTickets = ({ initialDate, finalDate, paperClass }) => {
  const [report, setReport] = useState(initialState);
  const theme = useTheme();
  const textColor = getChartTextColor(theme.palette.type === "dark");

  useEffect(() => {
    handleGetConvertedTickets(initialDate, finalDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialDate, finalDate]);

  const handleGetConvertedTickets = async (selectedInitialDate, selectedFinalDate) => {
    try {
      if (!selectedInitialDate || !selectedFinalDate) {
        return;
      }

      const { data } = await api.get("/dashboard/convertedTickets", {
        params: {
          initialDate: selectedInitialDate,
          finalDate: selectedFinalDate
        }
      });

      setReport({ ...initialState, ...data });
    } catch (error) {
      toast.error(i18n.t("dashboard.conversions.loadError"));
    }
  };

  const dataCharts = {
    labels: [i18n.t("dashboard.conversions.yes"), i18n.t("dashboard.conversions.no")],
    datasets: [
      {
        data: [report.sim, report.nao],
        backgroundColor: [SIM_COLOR, NAO_COLOR],
        borderWidth: 1
      }
    ]
  };

  const hasPie = report.sim > 0 || report.nao > 0;

  // Sem nenhuma classificação de conversão no período: não exibe o gráfico.
  if (!report.totalTickets) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <Paper className={paperClass}>
        <Typography component="h2" variant="h6" color="primary" gutterBottom>
          {i18n.t("dashboard.conversions.title")}
        </Typography>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={7}>
            <div style={{ height: "260px" }}>
              {hasPie && <Doughnut options={buildOptions(textColor)} data={dataCharts} />}
            </div>
          </Grid>

          <Grid item xs={12} md={5}>
            <Typography variant="subtitle1" gutterBottom>
              <strong>{i18n.t("dashboard.conversions.totalTickets")}:</strong> {report.totalTickets}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              <strong>{i18n.t("dashboard.conversions.totalConversions")}:</strong> {report.totalConversoes}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              <strong>{i18n.t("dashboard.conversions.conversionRate")}:</strong> {report.percentual}%
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {i18n.t("dashboard.conversions.notApplicable")}: {report.naoAplicavel}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};
